import style from "./team-cell-new.module.css";
import { useRef } from "react";
import { useHover } from "usehooks-ts";
import { TeamWithProjects } from "shared/datamodel/schemas/team";
import { Tooltip } from "frontend/ui-components/floaters/tooltip";

export function WorkspaceCellNew({ team }: { team: TeamWithProjects }) {
  const menuButtonRef = useRef<HTMLDivElement>(null);
  const teamNameRef = useRef<HTMLDivElement | null>(null);
  const hoverTeamName = useHover(teamNameRef);
  const hoverMenu = useHover(menuButtonRef);

  return (
    <div key={team.documentId} ref={teamNameRef} className={style.cell}>
      {hoverTeamName && team.name.length > 15 && (
        <Tooltip
          side="right"
          label={team.name}
          relativeTo={teamNameRef}
          withArrow={true}
          customStyle={{
            backgroundColor: "#EBEDF3",
            color: " #113357",
            fontSize: 12,
            fontWeight: 400,
            borderRadius: 4,
            marginLeft: 20,
            maxWidth: "500px",
            wordBreak: "break-word",
          }}
        />
      )}
      <div className={style.teamNameContainer}>
        <div
          className={style.teamName}
          style={{
            minWidth: "130px",
            maxWidth: "130px",
            overflow: "hidden",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
          }}
        >
          {team.name}
        </div>
      </div>
      <div className={style.menuContainer}>
        {hoverMenu && (
          <Tooltip
            side="top"
            label={"Settings"}
            relativeTo={menuButtonRef}
            customStyle={{
              backgroundColor: "#113357",
              borderRadius: 6,
              color: " #FFF",
              fontSize: 12,
              fontWeight: 300,
            }}
          />
        )}
      </div>
    </div>
  );
}
